// Use this for Local Development
// export const WEBSITE_URL = "http://127.0.0.1:8000";
export const WEBSITE_URL = "https://bhoomee.shop/public";
// export const WEBSITE_URL = "https://taza.co.in";

// Comment out the above and Uncomment the below line before building the files for Production
// export const WEBSITE_URL = "https://" + window.location.hostname + "/public";
